export const GET_CATEGORIES = 'categories/GET_CATEGORIES'
export const GET_CATEGORIES_SUCCESSFUL = 'categories/GET_CATEGORIES_SUCCESSFUL'
export const GET_CATEGORIES_FAILURE = 'categories/GET_CATEGORIES_FAILURE'
